import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "store/useSelector";

const CUSTOMER_KEY_IDX = 1; /* ["","ckey","dashboard","summaryGroup","detailKey"].indexOf("detailKey"); */

/**
 * Returns the ckey from the store, which syncs with the one from the url.
 * We use both because in storybook stories we currently fake the store instead of the route params
 */
export const useCustomerKey = (): string => {
  const { ckey } = useParams<{ ckey: string }>();
  const location = useLocation();
  /** fallback to the url to prevent first-render flash */
  const ckeyFromState = useSelector(state => state.customer.ckey);
  return useMemo(
    () =>
      location.pathname.split("/")[CUSTOMER_KEY_IDX] ??
      ckey ??
      ckeyFromState ??
      "",
    [ckeyFromState, ckey, location]
  );
};
